import React from 'react'
import logo from '../assets/logon.png'
const Navabr = () => {
  return (
    <div className="hero container max-w-screen-lg mt-4 mx-auto pb-10 flex justify-center">
        <img src={logo} alt="logo" className=" h-40 " />
      </div>
  )
}

export default Navabr